export default __webpack_public_path__ + "static/bill-payment-cc509100b792527d17d7bedb8a531aa3.png";